const Config = {
    USER_ID: 'BA45BOnEtzLHG_bhm',
    SERVICE_ID: 'service_o4nxaqh',
    TEMPLATE_ID: 'template_qdklqr9',
}

export default Config